import { Link } from 'react-router-dom'; 
import './Footer.css';

export default function Footer() {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">

          {/* ==== Quick Links ==== */}
          <div className="footer-column">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/About">About Us</Link></li>
              <li><Link to="/Contact">Contact</Link></li>
            </ul>
          </div>

          {/* ==== Service Links ==== */}
          <div className="footer-column">
            <h3>Service Links</h3>
            <ul>
              <li><Link to="/Whatastro">What Is Nadi Astrology</Link></li>
              <li><Link to="/Palmleaf">Palm Leaf Reading</Link></li>
              <li><Link to="/Remedies">Remedies</Link></li>
              <li><Link to="/Gallery">Gallery</Link></li>
              <li><Link to="/Prediction">Prediction</Link></li>
              <li><Link to="/Chapters">Chapters</Link></li>
              <li><Link to="/History">History</Link></li>
            </ul>
          </div>

          {/* ==== Contact ==== */}
          <div className="footer-column">
            <h3>Contact</h3>

  <ul style={{ marginTop: '15px' }}>
              <li>
  <strong style={{ color: '#ff8c00', fontWeight: '700' }}>
    Vaitheeswaran Kovil Office:
  </strong>
</li>

              <li>No.17B, Therku Veedhi,</li>
              <li>Mayiladuthurai Main Road,</li>
              <li>Vaitheeswaran Kovil,</li>
              <li>Mayiladuthurai District, Tamil Nadu – 609117.</li>
              <li>Phone: +91 74021 67580</li>
            </ul>

            <ul>
              <li>
    <strong style={{ color: '#ff8c00', fontWeight: '700' }}>
      Hyderabad Office:
    </strong>
  </li>
              <li>LIG-B, Plot No: 204, Dr. AS Rao Nagar Rd, beside SUB POST OFFICE,</li>
              <li>Anupuram Colony, A. S. Rao Nagar, Hyderabad, Secunderabad,</li>
              <li>Telangana – 500062.</li>
              <li>Phone: +91 74021 67580</li>
            </ul>

          
          </div>

          {/* ==== Map ==== */}
          <div className="footer-column">
            <h3>Our Location</h3>
            <div className="map-container">
              <iframe
                title="Hyderabad Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3806.917639619938!2d78.551817!3d17.480328!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb99351d957431%3A0x8b0ccf5bc455d61!2sLIG-B%2C%20Plot%20No%3A%20204%2C%20Dr.%20AS%20Rao%20Nagar%20Rd%2C%20beside%20SUB%20POST%20OFFICE%2C%20Anupuram%20Colony%2C%20A.%20S.%20Rao%20Nagar%2C%20Hyderabad%2C%20Secunderabad%2C%20Telangana%20500062!5e0!3m2!1sen!2sin!4v1730960735029!5m2!1sen!2sin"
                width="100%"
                height="150"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>

        {/* ==== Footer Bottom ==== */}
        <div className="footer-bottom">
          <p>
            © 2024 Shiva Nadi Astrology. <Link to="/PrivacyPolicy">Privacy Policy</Link> | <Link to="/TermsConditions">Terms & Conditions</Link>
          </p>
          <p>
            Built to inspire by <a href="https://semmssolutions.com/" id="semms">SEMMS Solutions</a> – Elevating Your Digital Journey!
          </p>
        </div>
      </footer>
    </>
  );
}
